import "./NotFound.css";
const NotFound = () => {
  return (
    <>
      <div className="NotFound"></div>
    </>
  );
};
export default NotFound;
